// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__10lMY","modalForm":"UpgradeEpcsModal_modalForm__XQfE3","modalFooter":"UpgradeEpcsModal_modalFooter__1eGHi"};